import React from "react";

/**
 * Icons per machine-view tab, used by the mobile bottom navigation (and the
 * desktop pill bar). Built-in tabs map by id; user-created dashboard tabs fall
 * back to a generic layout icon.
 */

const svg = (children: React.ReactNode) => (
  <svg
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

const HOME = svg(<path d="M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10" />);
const SLIDERS = svg(
  <>
    <path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M18 18h2" />
    <circle cx="15" cy="6" r="2" />
    <circle cx="9" cy="12" r="2" />
    <circle cx="15" cy="18" r="2" />
  </>,
);
const PULSE = svg(<path d="M3 12h4l2 6 4-14 2 8h6" />);
const CLOCK = svg(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </>,
);
const LAYOUT = svg(
  <>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18M9 21V9" />
  </>,
);

export function getTabIcon(id: string): React.ReactNode {
  switch (id) {
    case "overview":
      return HOME;
    case "preset":
      return SLIDERS;
    case "condition-monitoring":
      return PULSE;
    case "live-shift":
    case "liveShift":
      return CLOCK;
    default:
      return LAYOUT;
  }
}
